import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MuiPagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const Pagination = ({
	totalPages,
	currentPage,
	onPageChange,
	itemsPerPage,
	totalItems,
	itemLabel = "items",
	showResultsText = true,
	zeroBased = false,
}) => {
	const theme = useTheme();

	const pageForMui = zeroBased ? currentPage + 1 : currentPage;

	const startItem = totalItems ? (pageForMui - 1) * itemsPerPage + 1 : 0;

	const endItem = totalItems ? Math.min(pageForMui * itemsPerPage, totalItems) : 0;

	return (
		<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2, mt: 3, flexWrap: "wrap" }}>
			<MuiPagination
				count={totalPages}
				page={pageForMui}
				shape="rounded"
				variant="outlined"
				onChange={(event, page) => onPageChange(zeroBased ? page - 1 : page)}
				renderItem={(item) => <PaginationItem slots={{ previous: ArrowLeftIcon, next: ArrowRightIcon }} {...item} />}
				sx={{
					"& .MuiPaginationItem-root:not(.MuiPaginationItem-ellipsis)": {
						color: theme.palette.primary.main,
						backgroundColor: "#EBF5FF",
						borderColor: "#5BB8F5",
						fontWeight: "bold",
					},
					"& .MuiPaginationItem-root.Mui-selected": {
						color: theme.palette.primary.contrastText,
						backgroundColor: theme.palette.primary.main,
						borderColor: theme.palette.primary.light,
					},
				}}
			/>

			{showResultsText && totalItems != null && (
				<Typography variant="body2" color="text.secondary">
					{`Showing ${startItem}–${endItem} of ${totalItems} ${itemLabel}`}
				</Typography>
			)}
		</Box>
	);
};

export default Pagination;
